/* V4 product form: Shopify is authoritative for variants, money and stock. */
(() => {
  const root = document.getElementById('kk-page');
  if (!root || root.dataset.kkReady) return;
  root.dataset.kkReady = 'true';
  const $ = selector => root.querySelector(selector);
  const $$ = selector => [...root.querySelectorAll(selector)];
  const data = JSON.parse($('#kk-product-data').textContent);
  const form = $('.kk-product-form');
  const select = $('#kk-variant-id');
  const quantity = $('#kk-quantity');
  const buy = $('.kk-buy');
  const status = $('.kk-form-status');
  const express = $('.kk-express');
  const dialog = $('.kk-added');
  let pending = false;
  let selected = data.variants.find(v => String(v.id) === String(select.value));
  const images = $$('[data-gallery-index]');
  let slide = Math.max(0, images.findIndex(b => b.getAttribute('aria-pressed') === 'true'));
  const moneyText = html => {
    const textarea = document.createElement('textarea');
    textarea.innerHTML = html || '';
    const content = document.createElement('div');
    content.innerHTML = textarea.value;
    return content.textContent;
  };
  function image(src, alt, id) {
    const main = $('#kk-main-image');
    if (!main || !src) return;
    main.removeAttribute('srcset');
    main.src = src;
    main.alt = alt || data.title;
    images.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.imageId === String(id))));
    const next = images.findIndex(button => button.dataset.imageId === String(id));
    if (next >= 0) {
      slide = next;
      const button = images[next];
      const rail = button.parentElement;
      const left = button.getBoundingClientRect().left - rail.getBoundingClientRect().left + rail.scrollLeft;
      if (left < rail.scrollLeft || left + button.offsetWidth > rail.scrollLeft + rail.clientWidth) {
        rail.scrollTo({left: Math.max(0, left - (rail.clientWidth - button.offsetWidth) / 2), behavior: 'auto'});
      }
    }
  }
  function gallery(n) {
    if (!images.length) return;
    slide = (n + images.length) % images.length;
    const button = images[slide];
    image(button.dataset.src, button.dataset.alt, button.dataset.imageId);
  }
  images.forEach((button, index) => button.addEventListener('click', () => gallery(index)));
  $('.kk-prev')?.addEventListener('click', () => gallery(slide - 1));
  $('.kk-next')?.addEventListener('click', () => gallery(slide + 1));
  function normalizeQuantity() {
    const min = Number(quantity.min) || 1;
    const step = Number(quantity.step) || 1;
    const max = quantity.hasAttribute('max') ? Number(quantity.max) : Infinity;
    const input = Number(quantity.value);
    const value = Number.isFinite(input) ? input : min;
    const alignedMax = Number.isFinite(max) ? min + Math.max(0, Math.floor((max - min) / step)) * step : Infinity;
    quantity.value = String(Math.min(alignedMax, min + Math.max(0, Math.floor((value - min) / step)) * step));
  }
  function refreshAvailability() {
    buy.disabled = pending || !selected?.available;
    buy.querySelector('span').textContent = pending ? 'Adding…' : selected?.available ? 'Add to cart' : 'Sold out';
    express.hidden = !selected?.available;
    express.inert = pending;
    express.setAttribute('aria-busy', String(pending));
    quantity.disabled = pending;
    $$('[data-variant], [data-quantity-step]').forEach(button => button.disabled = pending);
  }
  function selectVariant(id, announce = true) {
    const variant = data.variants.find(v => String(v.id) === String(id));
    if (!variant || pending) return;
    selected = variant;
    select.value = String(variant.id);
    $$('[data-variant]').forEach(button => {
      const active = button.dataset.variant === String(variant.id);
      button.setAttribute('aria-pressed', String(active));
      if (active) button.hidden = false;
    });
    $('#kk-price').textContent = moneyText(variant.price_text);
    $('#kk-compare').textContent = moneyText(variant.compare_text);
    $('#kk-compare').hidden = !variant.on_sale;
    $('#kk-saving').textContent = 'Save ' + moneyText(variant.saving_text);
    $('#kk-saving').hidden = !variant.on_sale;
    quantity.min = String(variant.quantity_min || 1);
    quantity.step = String(variant.quantity_step || 1);
    if (variant.quantity_max != null) quantity.max = String(variant.quantity_max);
    else quantity.removeAttribute('max');
    normalizeQuantity();
    const media = variant.image || data.fallback_image;
    if (media) image(media.src, media.alt, media.id);
    refreshAvailability();
    const url = new URL(location.href);
    if (url.searchParams.has('variant') || announce) {
      url.searchParams.set('variant', variant.id);
      history.replaceState({}, '', url);
    }
    if (announce) select.dispatchEvent(new Event('change', {bubbles: true}));
  }
  $$('[data-variant]').forEach(button => button.addEventListener('click', () => selectVariant(button.dataset.variant)));
  select.addEventListener('change', () => {
    if (String(selected?.id) !== select.value) selectVariant(select.value, false);
  });
  quantity.addEventListener('change', normalizeQuantity);
  $$('[data-quantity-step]').forEach(button => button.addEventListener('click', () => {
    quantity.value = String((Number(quantity.value) || Number(quantity.min) || 1) + Number(button.dataset.quantityStep) * (Number(quantity.step) || 1));
    normalizeQuantity();
    quantity.dispatchEvent(new Event('change', {bubbles: true}));
  }));
  $('.kk-show-models')?.addEventListener('click', event => {
    const button = event.currentTarget;
    const open = button.getAttribute('aria-expanded') !== 'true';
    button.setAttribute('aria-expanded', String(open));
    button.textContent = open ? 'Show fewer options −' : `View all ${button.dataset.count} options +`;
    $$('.kk-extra-variant').forEach(item => item.hidden = !open && item.dataset.variant !== String(selected?.id));
  });
  $('.kk-menu-toggle')?.addEventListener('click', event => {
    const open = event.currentTarget.getAttribute('aria-expanded') !== 'true';
    event.currentTarget.setAttribute('aria-expanded', String(open));
    $('.kk-menu').hidden = !open;
  });
  selectVariant(select.value, false);
  form.addEventListener('submit', async event => {
    // Accelerated checkout remains Shopify-owned; only this form's add action is enhanced.
    if (event.submitter && event.submitter !== buy) return;
    event.preventDefault();
    if (pending || !selected?.available) return;
    normalizeQuantity();
    const body = new FormData(form); // Capture enabled controls before locking them.
    pending = true;
    refreshAvailability();
    status.textContent = '';
    try {
      const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
        method: 'POST', body, headers: {Accept: 'application/json'}
      });
      const added = await response.json();
      if (!response.ok) {
        status.textContent = added.description || 'This selection could not be added. Please review your option and quantity.';
        return;
      }
      $('.kk-added-detail').textContent = `${added.product_title || data.title}${added.variant_title ? ' · ' + added.variant_title : ''} · Quantity ${added.quantity}`;
      status.textContent = 'Added to your cart.';
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else location.assign(data.cart_url);
    } catch (_) {
      status.textContent = 'We could not confirm the cart response. Check your cart before trying again.';
      const link = document.createElement('a');
      link.href = data.cart_url;
      link.textContent = ' View cart';
      status.appendChild(link);
    } finally {
      pending = false;
      refreshAvailability();
    }
  });
  $('.kk-dialog-close')?.addEventListener('click', () => dialog.close());
  $('.kk-continue')?.addEventListener('click', () => dialog.close());
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const videos = $$('video');
  const visibleVideos = new Set();
  const userPaused = new WeakSet();
  const automaticPauses = new WeakSet();
  const automaticPlays = new WeakSet();
  const manualPlayback = new WeakSet();
  function pauseAutomatically(video) {
    manualPlayback.delete(video);
    if (video.paused) return;
    automaticPauses.add(video);
    video.pause();
  }
  videos.forEach(video => {
    video.addEventListener('pause', () => {
      manualPlayback.delete(video);
      if (automaticPauses.has(video)) automaticPauses.delete(video);
      else userPaused.add(video);
    });
    video.addEventListener('play', () => {
      if (automaticPlays.has(video)) automaticPlays.delete(video);
      else {
        userPaused.delete(video);
        manualPlayback.add(video);
      }
      if (document.hidden || !visibleVideos.has(video)) pauseAutomatically(video);
    });
  });
  function load(video) {
    const source = video.querySelector('source[data-src]');
    if (source && !source.src) { source.src = source.dataset.src; video.load(); }
  }
  function playIfAllowed(video) {
    if (document.hidden || !visibleVideos.has(video)) return pauseAutomatically(video);
    // Reduced motion never starts or resumes playback without a fresh native play action.
    if (reduced.matches) {
      if (!manualPlayback.has(video)) pauseAutomatically(video);
      return;
    }
    if (userPaused.has(video) || !video.paused) return;
    load(video);
    automaticPlays.add(video);
    video.play().catch(() => automaticPlays.delete(video));
  }
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(entries => entries.forEach(({target, isIntersecting, intersectionRatio}) => {
      if (isIntersecting && intersectionRatio >= .35) { visibleVideos.add(target); load(target); } else visibleVideos.delete(target);
      playIfAllowed(target);
    }), {threshold: .35});
    videos.forEach(video => observer.observe(video));
  } else {
    const updateVisibility = () => videos.forEach(video => {
      const bounds = video.getBoundingClientRect();
      const onScreen = bounds.bottom > 0 && bounds.top < window.innerHeight && bounds.right > 0 && bounds.left < window.innerWidth;
      if (onScreen) { visibleVideos.add(video); load(video); }
      else visibleVideos.delete(video);
      playIfAllowed(video);
    });
    document.addEventListener('scroll', updateVisibility, {passive: true, capture: true});
    window.addEventListener('resize', updateVisibility, {passive: true});
    updateVisibility();
  }
  document.addEventListener('visibilitychange', () => videos.forEach(playIfAllowed));
  reduced.addEventListener?.('change', () => videos.forEach(playIfAllowed));
})();

/* Optional interaction layer for below.liquid. Does not alter cart or Shopify state. */
(() => {
  const root = document.querySelector('.kk');
  if (!root || root.dataset.kkBelowReady) return;
  root.dataset.kkBelowReady = 'true';
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const moveTo = (track, index) => {
    const child = track?.children[index];
    if (!child) return;
    track.scrollTo({left: child.offsetLeft - track.children[0].offsetLeft, behavior: reducedMotion ? 'auto' : 'smooth'});
  };
  root.addEventListener('click', (event) => {
    const arrow = event.target.closest('[data-kk-scroll]');
    if (arrow) {
      const track = document.getElementById(arrow.dataset.kkScroll);
      if (track) track.scrollBy({left: (track.children[0]?.getBoundingClientRect().width || track.clientWidth) * Number(arrow.dataset.kkDirection), behavior: reducedMotion ? 'auto' : 'smooth'});
    }
    const dot = event.target.closest('[data-kk-slide]');
    if (dot) moveTo(document.getElementById(dot.closest('[data-kk-dots]').dataset.kkDots), Number(dot.dataset.kkSlide));
    const media = event.target.closest('[data-kk-show-media]');
    if (media) {
      const extra = root.querySelector('.kk-extra-media');
      if (extra) { extra.hidden = !extra.hidden; media.innerHTML = extra.hidden ? 'See<br>more' : 'See<br>less'; media.setAttribute('aria-expanded', String(!extra.hidden)); }
    }
  });
  root.querySelectorAll('[data-kk-dots]').forEach(dots => {
    const track = document.getElementById(dots.dataset.kkDots);
    if (!track) return;
    let ticking = false;
    track.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        const offsets = [...track.children].map(item => Math.abs(item.offsetLeft - track.children[0].offsetLeft - track.scrollLeft));
        const index = offsets.indexOf(Math.min(...offsets));
        dots.querySelectorAll('button').forEach((item, i) => { item.classList.toggle('is-active', i === index); item.setAttribute('aria-current', i === index ? 'true' : 'false'); });
        ticking = false;
      });
    }, {passive: true});
  });
  root.querySelectorAll('.kk-faq-list details').forEach(item => item.addEventListener('toggle', () => {
    if (item.open) root.querySelectorAll('.kk-faq-list details').forEach(other => { if (other !== item) other.open = false; });
  }));

})();

/* Relative dates derive solely from the documented original review date. */
(() => {
  const dayMs = 86400000;
  const today = Math.floor(Date.now() / dayMs);
  document.querySelectorAll('.kk time[data-review-date]').forEach(time => {
    const sourceDate = time.getAttribute('datetime');
    if (!/^\d{4}-\d{2}-\d{2}$/.test(sourceDate || '')) return;
    const sourceDay = Math.floor(Date.parse(sourceDate + 'T00:00:00Z') / dayMs);
    if (!Number.isFinite(sourceDay) || sourceDay > today) return;
    const days = today - sourceDay;
    time.textContent = days === 0 ? 'Today' : days === 1 ? '1 day ago' : `${days} days ago`;
  });
})();

/* Review photos open independently from the product and cart dialogs. */
(() => {
  const root = document.getElementById('kk-page');
  const dialog = root?.querySelector('.kk-photo-dialog');
  if (!dialog || dialog.dataset.kkPhotoReady) return;
  const photo = dialog.querySelector('img');
  const caption = dialog.querySelector('.kk-photo-caption');
  const closeButton = dialog.querySelector('.kk-photo-close');
  if (!photo || !caption || !closeButton) return;
  dialog.dataset.kkPhotoReady = 'true';
  let returnFocus = null;
  const restoreFocus = () => {
    const trigger = returnFocus;
    returnFocus = null;
    if (trigger?.isConnected) trigger.focus({preventScroll: true});
  };
  const close = () => {
    if (typeof dialog.close === 'function') dialog.close();
    else {
      dialog.removeAttribute('open');
      restoreFocus();
    }
  };
  root.addEventListener('click', event => {
    const trigger = event.target.closest?.('button[data-review-photo]');
    if (!trigger || !root.contains(trigger)) return;
    let source;
    try { source = new URL(trigger.dataset.reviewPhoto, document.baseURI); }
    catch (_) { return; }
    if (!['https:', 'http:'].includes(source.protocol)) return;
    event.preventDefault();
    returnFocus = trigger;
    photo.removeAttribute('srcset');
    photo.src = source.href;
    photo.alt = trigger.dataset.reviewPhotoAlt || 'Customer photo';
    caption.textContent = photo.alt;
    if (!dialog.open) {
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');
    }
    closeButton.focus({preventScroll: true});
  });
  closeButton.addEventListener('click', close);
  dialog.addEventListener('close', restoreFocus);
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const bounds = dialog.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right ||
        event.clientY < bounds.top || event.clientY > bounds.bottom) close();
  });
  dialog.addEventListener('keydown', event => {
    if (event.key === 'Escape' && typeof dialog.showModal !== 'function') {
      event.preventDefault();
      close();
    }
  });
})();
